// extracted by mini-css-extract-plugin
module.exports = {"card":"styles__card___uWvjq","title":"styles__title___3wK_2","titleLarge":"styles__titleLarge___3zXCw","center":"styles__center___325RM","buttonIcon":"styles__buttonIcon___3NfYt"};